var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"label":_vm.label,"items":_vm.choices,"return-object":"","rules":_vm.select_rules,"disabled":_vm.disabled},on:{"input":_vm.onChange},model:{value:(_vm.internal_value),callback:function ($$v) {_vm.internal_value=$$v},expression:"internal_value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }